<template>
    <div class="about" style="height: 450px">
        <h3>关于我们</h3>
        <span>{{query.content}}</span>
        <input type="file" id="fileToRichText" v-show="hideUpload" accept="image/*">
        <quill-editor
                ref="quillRef"
                :options="modules"
                class="editor"
                content-type="html"
                style="height:100%"
                :content="query.content" placeholder="输入关于我们">

        </quill-editor>

        <div style="margin-top: 20px">
            <el-button type="primary" @click="onSubmit">更新</el-button>
        </div>
    </div>
</template>

<script setup>
    import { defineComponent, onMounted, reactive,ref, nextTick, unref} from 'vue';
    import ImageUploader from 'quill-image-uploader';
    import {ElMessage} from "element-plus/lib/components";
    import {aboutInfo,aboutInfoUpdate} from '@/api/system/aboutInfo'
    import {upload} from '@/api/upload'
    const hideUpload = ref(false)
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
        ['blockquote', 'code-block'], //引用，代码块
        [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
        [{ 'list': 'ordered' }, { 'list': 'bullet' }], //列表
        [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
        [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
        [{ 'direction': 'rtl' }], // 文本方向
        [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], //几级标题
        [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
        [{ 'font': [] }], //字体
        [{ 'align': [] }], //对齐方式
        ['clean'], //清除字体样式
        ['image'] //上传图片、上传视频
    ];
    const modules = {
        name: 'imageUploader',
        modules:{
            toolbar:{
                container:toolbarOptions,
                handlers:{
                    "image":file => {
                        //此处需要input输入框和文本编辑器配合使用
                        //出发点击事件
                        document.getElementById('fileToRichText').click()
                        //监听input框变化
                        document.getElementById('fileToRichText').addEventListener('change', uploadImage);
                    }
                }
            }
        }
    }
    function uploadImage(){
        var fileInput = document.getElementById('fileToRichText');
        var file = fileInput.files[0];
        var formData = new FormData();
        // 将文件添加到FormData对象
        formData.append('file', file);
        upload(formData).then(data=>{
            console.log("上传成功")
            let quill = quillRef.value.getQuill()
            let length = 0
            if(quill.getSelection() != null){
                length = quill.getSelection().index
            }
            quill.insertEmbed(length,'image',data.data);
            quill.setSelection(length+1)
        })
    }
    let quillRef = ref(null)
    let query = reactive({
        content: "",
    })
    function onSubmit(){
        console.log("提交了",query, quillRef.value.getHTML())
        let params = {
            content:quillRef.value.getHTML()
        }
        aboutInfoUpdate(params).then(data=>{
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '修改成功',
                    type: 'success',
                })
            }
        })
    }
    onMounted(() => {
        aboutInfo().then(data=>{
            // query.content = data.data.content
            quillRef.value.setHTML(data.data.content)
        })
    })
</script>

<style lang="scss" scoped>
.about{
    width: 95%;
    margin: 0 auto;
    h3{
        margin: 20px 0;
    }
}
</style>
